// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"9e3ae57d","86":"eea4fbd3","126":"ba5d46fb","272":"4b630d0e","283":"3b6d5537","453":"821fd3de","509":"0ec00735","773":"bdd394ab","780":"ee95fa06","831":"68ea4e6e","836":"155f4508","842":"d3231441"}[chunkId] + ".chunk.js";
};